import appConfig from "../../app-config";

const UserStorage = {
    getItems(key) {
        return localStorage.getItem(key);
    },
    saveItems(key, value) {
        localStorage.setItem(key, value);
    },
    clear() {
        localStorage.removeItem(`UserFirstName_${appConfig.VUE_APP_COOKIE_NAME}`);
        localStorage.removeItem(`SessionId_${appConfig.VUE_APP_COOKIE_NAME}`);
        localStorage.removeItem(`globalFields_${appConfig.VUE_APP_COOKIE_NAME}`);
    },
};

export { UserStorage };
